import Joi from 'joi';
import { AxiosError } from 'axios';
import api from '../api';

const passengerSchema = Joi.object({
  id: Joi.number().required(),
  fullname: Joi.string().required(),
  category: Joi.string().valid('adult', 'child', 'infant', 'animal', 'group').required(),
  identityFiles: Joi.array().items(Joi.string()).required(),
});

/**
 * Get customer's passengers List
 * @param {number} customerId - id of the customer.
 * @returns {Promise<{passengers: CustomerPassenger[]}>} - The list of passengers.
 */
export const getPassengers = async (customerId) => {
  const result = await api.get(`customers/${customerId}/passengers`);

  try {
    const schema = Joi.object({
      passengers: Joi.array().items(passengerSchema),
    }).required();

    await schema.validateAsync(result.data, { allowUnknown: true });
  } catch (/** @type {any} */ error) {
    throw new AxiosError('', `API response do not match Passenger list Schema : ${error.message}`);
  }

  return result.data.passengers;
};

/**
 * Create a new passenger
 * @param {{customerId: number, passenger: CustomerPassenger}} passenger
 * @returns {Promise<any>} - 201 return code
 */
export const createPassenger = async ({ customerId, passenger }) => {
  const result = await api.post(`/customers/${customerId}/passengers`, { passengers: [passenger] });
  return result.status;
};

/**
 * Update a passenger
 * @param {{customerId: number, passenger: CustomerPassenger}} passenger - The passenger to update
 * @returns {Promise<any>} - 204 return code
 */
export const updatePassenger = async ({ customerId, passenger }) => {
  const result = await api.put(`/customers/${customerId}/passengers/${passenger.id}`, passenger);
  return result.status;
};

/**
 * delete a passenger by id
 * @param {object} param - The passenger id.
 * @param {number} param.customerId - The customer id.
 * @param {number} param.passengerId - The passenger id.
 * @returns {Promise<any>} - 204 return code
 */
export const deletePassenger = async ({ customerId, passengerId }) => {
  const result = await api.delete(`/customers/${customerId}/passengers/${passengerId}`);
  return result.status;
};
